// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + (chunkId === 85 ? "lazy-app" : chunkId) + "." + {"46":"49e861ac45202320eefd","85":"ef58de7b9c7b89690688"}[chunkId] + ".js";
};